import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ShieldIcon, RotateCwIcon, PlusIcon, GithubIcon, LinkedinIcon, GlobeIcon } from 'lucide-react';
interface SafariAppProps {
  type: 'github' | 'linkedin' | 'portfolio';
}
const CONFIG = {
  github: {
    url: 'https://github.com/Dev-emmy-001',
    displayUrl: 'github.com/Dev-emmy-001',
    title: 'GitHub – Dev-emmy-001',
    heading: 'Emmanuel Saka on GitHub',
    sub: 'Check out my repositories, contributions, and open-source projects.',
    btnLabel: 'View Profile',
    btnClass: 'bg-[#2da44e] hover:bg-[#2c974b]',
    iconBg: 'bg-gray-100 dark:bg-[#21262d]',
    Icon: GithubIcon,
    iconColor: 'text-gray-800 dark:text-white'
  },
  linkedin: {
    url: 'https://www.linkedin.com/in/saka-emmanuel-01b43923b',
    displayUrl: 'linkedin.com/in/saka-emmanuel...',
    title: 'LinkedIn – Emmanuel Saka',
    heading: 'Emmanuel Saka on LinkedIn',
    sub: 'Connect with me professionally, view my experience and endorsements.',
    btnLabel: 'Open Profile',
    btnClass: 'bg-[#0a66c2] hover:bg-[#004182]',
    iconBg: 'bg-blue-50 dark:bg-[#21262d]',
    Icon: LinkedinIcon,
    iconColor: 'text-[#0a66c2]'
  },
  portfolio: {
    url: 'https://dev-emmy-001.github.io/dev-emmy-portfolio/',
    displayUrl: 'dev-emmy-001.github.io/dev-emmy-portfolio',
    title: 'Dev-Emmy Portfolio',
    heading: 'Dev-Emmy Portfolio',
    sub: 'My live developer portfolio — explore my work, skills, and how to get in touch.',
    btnLabel: 'Open Live Portfolio',
    btnClass: 'bg-[#1d1d1f] hover:bg-black',
    iconBg: 'bg-gray-100 dark:bg-[#21262d]',
    Icon: GlobeIcon,
    iconColor: 'text-blue-500'
  }
} as const;
export const SafariApp: React.FC<SafariAppProps> = ({
  type
}) => {
  const cfg = CONFIG[type];
  const {
    Icon
  } = cfg;
  return <div className="h-full w-full bg-white dark:bg-[#1e1e1e] flex flex-col text-gray-900 dark:text-gray-100" data-id="element-157" data-mp="14cl04eeia5zz">
      {/* Safari Chrome */}
      <div className="bg-[#f5f5f7] dark:bg-[#2d2d2d] border-b border-gray-300 dark:border-black/50" data-id="element-158" data-mp="18g97ox3511l8">
        {/* Tabs */}
        <div className="flex items-end px-2 pt-2 gap-1" data-id="element-159" data-mp="3b37mu9tj1i45">
          <div className="ml-20" data-id="element-160" data-mp="363l97z9sdzut" />
          <div className="bg-white dark:bg-[#404040] px-4 py-1.5 rounded-t-lg text-xs font-medium flex items-center gap-2 min-w-[200px] border-x border-t border-gray-300 dark:border-black/20 relative z-10" data-id="element-161" data-mp="364d232c01jhe">
            <Icon size={14} data-id="element-162" data-mp="2wamh47f2zr6g" />
            <span className="truncate flex-1" data-id="element-163" data-mp="2sbeveju3w4yj">{cfg.title}</span>
          </div>
          <button className="p-1.5 hover:bg-black/5 dark:hover:bg-white/10 rounded-md mb-1 transition-colors" data-id="element-164" data-mp="2nbsi6aea2opq">
            <PlusIcon size={14} data-id="element-165" data-mp="2ic61fqz8qqc6" />
          </button>
        </div>

        {/* Toolbar */}
        <div className="h-12 flex items-center px-4 gap-4 bg-white dark:bg-[#404040] border-b border-gray-300 dark:border-black/50" data-id="element-166" data-mp="2ddur7f51adtf">
          <div className="flex items-center gap-2 text-gray-500 dark:text-gray-400" data-id="element-167" data-mp="gk9s8o0jpskk">
            <button className="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded transition-colors" data-id="element-168" data-mp="blzxgeiqgtzh">
              <ChevronLeftIcon size={20} data-id="element-169" data-mp="k41rhaiok5y4" />
            </button>
            <button className="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded transition-colors opacity-50" data-id="element-170" data-mp="o4u5eh2hyz0q">
              <ChevronRightIcon size={20} data-id="element-171" data-mp="svtxn90o8sww" />
            </button>
            <button className="p-1 hover:bg-black/5 dark:hover:bg-white/10 rounded transition-colors" data-id="element-172" data-mp="sxn86zeenxa6">
              <RotateCwIcon size={16} data-id="element-173" data-mp="xwrkhywmmb4q" />
            </button>
          </div>

          <div className="flex-1 max-w-2xl mx-auto bg-black/5 dark:bg-black/20 rounded-md h-8 flex items-center px-3 gap-2 text-sm" data-id="element-174" data-mp="15z0iq6knyxo">
            <ShieldIcon size={14} className="text-gray-400" data-id="element-175" data-mp="a52jzv9nigcp" />
            <span className="text-gray-800 dark:text-gray-200 truncate" data-id="element-176" data-mp="a3hq87v5v1fw">
              {cfg.displayUrl}
            </span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 bg-[#f0f2f5] dark:bg-[#0d1117] flex items-center justify-center p-8 overflow-y-auto mac-scrollbar" data-id="element-177" data-mp="1ljg3knxdg9mx">
        <div className="bg-white dark:bg-[#161b22] border border-gray-200 dark:border-[#30363d] rounded-xl p-8 max-w-md w-full text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-178" data-mp="1qlf8414ulclg">
          <div className={`w-20 h-20 mx-auto ${cfg.iconBg} rounded-full flex items-center justify-center mb-6`} data-id="element-179" data-mp="2uir3ojzk3nq6">
            <Icon size={40} className={cfg.iconColor} data-id="element-180" data-mp="33hul7jj2rv2k" />
          </div>
          <h2 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white" data-id="element-181" data-mp="33gjk5rh0l1f5">
            {cfg.heading}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mb-8" data-id="element-182" data-mp="3dg1zfulzbz0v">{cfg.sub}</p>
          <a href={cfg.url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium text-white transition-all hover:-translate-y-0.5 ${cfg.btnClass}`} data-id="element-183" data-mp="3dfsamaco7xwr">
            {cfg.btnLabel} <ExternalLinkIcon size={16} data-id="element-184" data-mp="510c6jxrw96x" />
          </a>
        </div>
      </div>
    </div>;
};
const ExternalLinkIcon = ({
  size
}: {
  size: number;
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-185" data-mp="jn76v0raqzts">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" data-id="element-186" data-mp="ojo3ykgh4oj0"></path>
    <polyline points="15 3 21 3 21 9" data-id="element-187" data-mp="9oi1u8ki19uy"></polyline>
    <line x1="10" y1="14" x2="21" y2="3" data-id="element-188" data-mp="enbc7s4hokqw"></line>
  </svg>;